import { useQuery } from '@apollo/client'
import { listAllAppointmentInfos } from '../../models/graphqlTypes'
import { LIST_ALL_APPOINTMENT_INFO } from '../../operations/appointmentOperations'
import { QueryHookOptions } from '@apollo/client/react/types/types'

export type AppointmentType =
  listAllAppointmentInfos['listAllAppointmentInfos'][number]

type Options = QueryHookOptions<listAllAppointmentInfos>

type ReturnTypes = {
  loading: boolean
  appointmentTypes: AppointmentType[]
}

export const useAllAppointmentTypes = (options: Options = {}): ReturnTypes => {
  const { data: appointmentTypeData, loading } =
    useQuery<listAllAppointmentInfos>(LIST_ALL_APPOINTMENT_INFO, options)

  const appointmentTypes = appointmentTypeData?.listAllAppointmentInfos || []

  return {
    loading,
    appointmentTypes,
  }
}
